import React from "react";
import VideoTriggerButton from "./VideoTriggerButton";

interface VehicleAnimationProps {
  onVideoOpen: () => void;
}

const VehicleAnimation = ({ onVideoOpen }: VehicleAnimationProps) => {
  return (
    <div className="flex-1 flex justify-center items-center relative px-2">
      <VideoTriggerButton onVideoOpen={onVideoOpen} />
    </div>
  );
};

const ExhaustSmoke = () => {
  // Removed for performance - too many animated elements
  return null;
};

export default VehicleAnimation;
